import React, { useEffect, useMemo, useState } from "react";
import swal from "sweetalert";
import PageTitle from "../../layouts/PageTitle";

// Import EditUserProfile components
import UserHeader from "./EditUserProfile/UserHeader";
import UserDetailsTable from "./EditUserProfile/UserDetailsTable";
import EditSections from "./EditUserProfile/EditSections";
import OtpModal from "./EditUserProfile/OtpModal";
import EditEmailModal from "./EditUserProfile/EditEmailModal";
import ChangePasswordModal from "./EditUserProfile/ChangePasswordModal";

import {
  getAllUserProfileList,
  updateUserProfileDetails,
  uploadUserDocument,
  sendMobileOtp,
  updateUserMobileNumber,
  updateUserEmailDirect,
  getmedicalhistory,
  checkUpdate,
  getKitSizes,
  getStateList,
  getDistrictList,
  deleteUploadDocument,
  getUserCategoryMain,
  getCategoryTypesByMain,
  getCategorySubTypesByType,
  updateUserType,
} from "../../../services/userApiService/userService";
import { validateSections, validateBank } from "../../../utils/validator";

// Alert wrapper
const notify = (type, message) =>
  swal(type === "error" ? "Error" : "Success", message, type);

// Default section field values
const getDefaultSectionValues = (userData = {}, entity = {}) => ({
  first_name: userData.first_name || "",
  middle_name: userData.middle_name || "",
  last_name: userData.last_name || "",
  dob: entity.dob || "",
  district: entity.city || "",
  city: entity.city_name || entity.district_name || "",
  pincode: entity.pincode || "",
  landmark: entity.landmark || "",
  country: entity.country_name || entity.country || "",
  state: entity.state_name || entity.state || "",
  address: entity.address || "",
  mobile: entity.mobile || "",
  email: userData.email || "",
  kit_size: entity.kit_size || "",
  shoe_size: entity.shoe_size || "",
  height: entity.height || "",
  weight: entity.weight || "",
  blood_group: entity.blood_group || "",
  identification_type: entity.identification_type || "",
  identification_number: entity.identification_number || "",
  bank_name: entity.bank_name || "",
  account_holder_name: entity.account_holder_name || "",
  account_number: entity.bank_account_number || "",
  branch_name: entity.branch_name || "",
  ifsc_code: entity.ifsc_code || "",
  sport_id: entity.sport_id || "",
  file: null,
  fileUrl: "",
  category_main_id: "",
  category_type_id: "",
  sub_category_type_id: "",
});

// Map section name to doc_name
const getDocNameFromField = (field = "") => {
  const map = {
    name: "name_image",
    address: "address_image",
    bank_details: "cancelled_cheque_or_passbook",
    kit_size: "kit_size_image",
    identification: "identification_image",
    shoe_size: "shoe_size_image",
    height: "height_image",
    weight: "weight_image",
    blood_group: "blood_group_image",
    dob: "dob_image",
    profile: "profile_image",
  };
  return map[field.toLowerCase()] || "supportive_document";
};

const EditProfileRequest = () => {
  const [userData, setUserData] = useState({});
  console.log("userData======>",userData)
  const [userProfileImage, setUserProfileImage] = useState(null);
  const [sections, setSections] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [mobileForm, setMobileForm] = useState({ prev: "", next: "", otp: "", otpSent: false });
  const [mainCategories, setMainCategories] = useState([]);
  const [categoryTypes, setCategoryTypes] = useState({});
  const [subCategories, setSubCategories] = useState({});
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [kitSizeList, setKitSizeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  const id = localStorage.getItem("id");
  const userCategoryMain = localStorage.getItem("user_category_main");
  const loggedInUserData = JSON.parse(localStorage.getItem("userData") || "{}");
  const loggedInStateId = loggedInUserData?.indivisual?.state;
  console.log(loggedInStateId);

  const entity = useMemo(() => userData?.indivisual || userData?.organization_profile || {}, [userData]);
  const docs = useMemo(() => userData?.indivisual_docs || [], [userData]);

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const res = await getAllUserProfileList(userCategoryMain, id);
      const data = res?.data?.data || {};
      setUserData(data);
      const docs = data?.indivisual_docs?.filter((item) => {
        if (item.doc_name === "profile_image") {
          return item.doc_file
        }
      })
      console.log({ docs })
      setUserProfileImage(docs?.[0]?.doc_file || null);

      const medicalRes = await getmedicalhistory();
      setMedicalHistory(medicalRes?.data?.data || []);

      const kitSizeRes = await getKitSizes();
      setKitSizeList(kitSizeRes?.data?.data || []);

      try {
        const catRes = await getUserCategoryMain();
        setMainCategories(catRes?.data?.data || catRes?.data || []);
      } catch (err) {
        console.error("Failed fetching main categories", err);
      }

      const stateRes = await getStateList();
      setStateList(stateRes?.data || []);

      if (loggedInStateId) {
        try {
          const distRes = await getDistrictList(loggedInStateId);
          setDistrictList(distRes?.data || []);
        } catch (err) {
          console.error("Error fetching districts for restricted state", err);
        }
      }

      // Determine entity again here just for default values init
      const ent = data?.indivisual || data?.organization_profile || {};
      setSections([{ id: Date.now(), field: "", values: getDefaultSectionValues(data, ent) }]);
    } catch (err) {
      console.error("Failed fetching user data", err);
      notify("error", "Could not load user data");
    }
  };

  const addSection = () =>
    setSections((prev) => [
      ...prev,
      { id: Date.now(), field: "", values: getDefaultSectionValues(userData, entity) },
    ]);

  const removeSection = (id) => setSections((prev) => prev.filter((s) => s.id !== id));

  const onFieldChange = async (id, field) => {
    // Check for "edit once" fields
    const restrictedFields = {
      dob: "dob",
      blood_group: "blood_group",
      identification: "identification", // Mapped as per user request
      sport: "sport",
      state: "state",
      // Mapped as per user request

    };

    if (restrictedFields[field]) {
      try {
        const payload = { checkFieldUpdate: restrictedFields[field] };
        const res = await checkUpdate(payload);

        // If status is false, it means check failed (e.g. not editable)
        if (res?.data?.status === false) {
          notify("error", res?.data?.message || "This field cannot be edited");
          return; // Block selection
        }
      } catch (err) {
        console.error("Check update failed", err);
        const errorMessage = err?.response?.data?.message || "Error checking field editability";
        notify("error", errorMessage);
        return; // Block selection on error
      }
    }

    if (field === "address") {
      const stateId = entity?.state || loggedInStateId || "";
      if (stateId) {
        try {
          const res = await getDistrictList(stateId);
          setDistrictList(res?.data || []);
        } catch (err) {
          console.error("Error fetching districts", err);
          setDistrictList([]);
        }
      } else {
        setDistrictList([]);
      }
    }

    setSections((prev) =>
      prev.map((s) => {
        if (s.id !== id) return s;

        const newValues = { ...getDefaultSectionValues(userData, entity) };

        switch (field) {
          case "name":
            newValues.first_name = userData?.first_name || "";
            newValues.middle_name = userData?.middle_name || "";
            newValues.last_name = userData?.last_name || "";
            break;
          case "dob":
            newValues.dob = entity?.dob || "";
            break;
          case "address":
            newValues.district = entity?.city || "";
            newValues.city = entity?.city_name || entity?.district_name || "";
            newValues.country = entity?.country_name || entity?.country || "";
            newValues.state = entity?.state_name || entity?.state || loggedInStateId || "";

            newValues.pincode = entity?.pincode || "";
            newValues.pincode = entity?.pincode || "";
            newValues.landmark = entity?.landmark || "";
            break;
          case "state":
            newValues.state = entity?.state_name || entity?.state || "";
            break;
          case "kit_size":
            newValues.kit_size = entity?.kit_size || "";
            break;
          case "identification":
            newValues.identification_type = entity?.identification_type || "";
            newValues.identification_number = entity?.identification_number || "";
            break;
          case "shoe_size":
            newValues.shoe_size = entity?.shoe_size || "";
            break;
          case "height":
            newValues.height = entity?.height || "";
            break;
          case "weight":
            newValues.weight = entity?.weight || "";
            break;
          case "blood_group":
            newValues.blood_group = entity?.blood_group || "";
            break;
          case "bank_details":
            newValues.bank_name = entity?.bank_name || "";
            newValues.account_holder_name = entity?.account_holder_name || "";
            newValues.account_number = entity?.bank_account_number || "";
            newValues.branch_name = entity?.branch_name || "";
            newValues.ifsc_code = entity?.ifsc_code || "";
            break;
          case "sport":
            newValues.sport_id = entity?.sport_id || "";
            break;
          case "profile":
            newValues.photofileUrl = userProfileImage || "";
            break;
          case "user_type":
            newValues.category_main_id = userCategoryMain || "";
            newValues.category_type_id = "";
            newValues.sub_category_type_id = "";
            break;
          default:
            break;
        }

        return { ...s, field, values: newValues };
      })
    );

    if (field === "user_type" && userCategoryMain) {
      handleCategoryMainChange(id, userCategoryMain);
    }
  };

  const onValueChange = (id, key, value) =>
    setSections((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, values: { ...s.values, [key]: value } } : s
      )
    );

  const handleStateChange = async (sectionId, stateId) => {
    onValueChange(sectionId, "state", stateId);
    onValueChange(sectionId, "district", ""); // Reset district

    if (!stateId) {
      setDistrictList([]);
      return;
    }

    try {
      const res = await getDistrictList(stateId);
      setDistrictList(res?.data || []);
    } catch (err) {
      console.error("Error fetching districts", err);
      setDistrictList([]);
    }
  };

  const handleCategoryMainChange = async (sectionId, mainId) => {
    if (!mainId) return;
    try {
      const res = await getCategoryTypesByMain(mainId);
      const types = res?.data?.data || res?.data || [];
      setCategoryTypes((prev) => ({ ...prev, [mainId]: types }));
    } catch (err) {
      console.error("Failed fetching category types", err);
    }
  };

  const handleCategoryTypeChange = async (sectionId, typeId) => {
    if (!typeId) return;
    try {
      const res = await getCategorySubTypesByType(typeId);
      const subs = res?.data?.data || res?.data || [];
      setSubCategories((prev) => ({ ...prev, [typeId]: subs }));
    } catch (err) {
      console.error("Failed fetching sub categories", err);
    }
  };

  const handleFileUpload = async (id, file, isPhoto = false) => {
    if (!file) return;

    const section = sections.find((s) => s.id === id);
    if (!section?.field && !isPhoto) {
      notify("error", "Select a field before uploading a document");
      return;
    }

    // Validate file type - only allow PNG, JPG, JPEG images
    const allowedTypes = ["image/png", "image/jpg", "image/jpeg", "application/pdf" ];
    if (!allowedTypes.includes(file.type)) {
      notify("error", "Only PNG, JPG, and JPEG and PDF files are allowed");
      return;
    }

    // Validate file size - max 2MB
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      notify("error", "File size must be less than 2MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", userData.id || id);
    let docName = isPhoto ? "profile_image" : getDocNameFromField(section.field);

    if (!isPhoto && section.field === "identification") {
      if (section.values.identification_type === "aadhaar") {
        docName = "aadhaar";
      } else if (section.values.identification_type === "pan_card") {
        docName = "pan_card";
      }
    }

    formData.append("doc_name", docName);

    try {
      const res = await uploadUserDocument(formData);
      const { id: docId, doc_file } = res?.data?.data || {};
      if (docId) {
        setSections((prev) =>
          prev.map((s) =>
            s.id === id
              ? {
                ...s,
                values: {
                  ...s.values,
                  [isPhoto ? "photoDocumentId" : "documentId"]: docId,
                  [isPhoto ? "photofileUrl" : "fileUrl"]: doc_file,
                  [isPhoto ? "photofile" : "file"]: file,
                  [`${s.field.toLowerCase()}_document`]: file,
                  ...(s.field === "bank_details" ? { cancelled_cheque_or_passbook: file } : {}),
                },
              }
              : s
          )
        );
        notify("success", `${isPhoto ? "Photo" : "Document"} uploaded successfully`);
      } else throw new Error("Invalid upload response");
    } catch (err) {
      console.error("Upload failed", err);
      notify("error", "File upload failed. Please try again.");
    }
  };

  const handleFileRemove = async (sectionId) => {
    const section = sections.find((s) => s.id === sectionId);
    if (!section) return;

    const values = section.values;
    // Check for either regular document or photo document
    const docId = values.documentId || values.photoDocumentId;

    if (docId) {
      try {
        const res = await deleteUploadDocument(docId);
        if (res?.data?.status) {
          notify("success", "Document removed successfully");
        } else {
          notify("error", res?.data?.message || "Failed to remove document");
          // Optional: return here if we don't want to clear UI on failure
          // but usually it's better to let user retry or just clear it locally if it's gone
        }
      } catch (err) {
        console.error("Error deleting document", err);
        notify("error", "Error removing document");
      }
    }

    // Clear local state regardless of API success (or if no ID existed yet)
    // We need to clear: file, fileUrl, documentId, and the specific field name
    setSections((prev) =>
      prev.map((s) => {
        if (s.id !== sectionId) return s;

        // Determine the specific doc key to clear (e.g., name_document, etc.)
        const docKey = getDocNameFromField(s.field);
        const isPhoto = s.field === "profile";

        let specificDocKey = docKey;
        if (s.field === "identification") {
          if (s.values.identification_type === "aadhaar") specificDocKey = "aadhaar";
          else if (s.values.identification_type === "pan_card") specificDocKey = "pan_card";
        }


        const newValues = { ...s.values };

        if (isPhoto) {
          // Clear only the uploaded document fields, NOT the userProfileImage
          // This allows the "Previous Photo" to remain visible
          delete newValues.photofile;
          delete newValues.photofileUrl;
          delete newValues.photoDocumentId;
          delete newValues.profile_image;

          // Also clear generic fields because the UI uses the generic uploader for "profile" field
          delete newValues.file;
          delete newValues.fileUrl;
          delete newValues.documentId;

          // DO NOT clear userProfileImage - it should show the current profile image
          // setUserProfileImage(null); // REMOVED - this was causing the bug
        } else {
          delete newValues.file;
          delete newValues.fileUrl;
          delete newValues.documentId;
          // Clear the mapped document key
          delete newValues[`${s.field.toLowerCase()}_document`];
          // Special case for identification dynamic keys
          if (s.field === "identification") {
            delete newValues.aadhaar;
            delete newValues.pan_card;
            delete newValues.identification_document;
          }
          if (s.field === "bank_details") {
            delete newValues.cancelled_cheque_or_passbook;
          }
        }

        return {
          ...s,
          values: newValues,
        };
      })
    );
  };

  console.log(stateList, districtList);

  const onSubmit = async (e) => {
    e.preventDefault();

    const selected = sections.filter((s) => !!s.field);

    if (selected.length === 0) {
      notify("error", "Please select fields before submit");
      return;
    }
    const validation = validateSections(selected);
    if (!validation.valid) {
      setValidationErrors(validation.errorsById || {});
      return;
    }
    setValidationErrors({});

    try {
      setIsSubmitting(true);

      const userTypeSections = selected.filter((s) => s.field === "user_type");
      const otherSections = selected.filter((s) => s.field !== "user_type");

      // Handle user_type directly — no admin approval needed
      for (const s of userTypeSections) {
        const v = s.values || {};
        const res = await updateUserType({
          category_main_id: v.category_main_id,
          category_type: v.category_type_id,
          sub_category_type: v.sub_category_type_id || null,
        });
        if (!res?.data?.status) {
          notify("error", res?.data?.message || "Failed to update user type");
          return;
        }
      }

      if (otherSections.length > 0) {
        const payload = {
          user_id: Number(id || ""),
          meta_value: {},
          status: "pending",
          comment: "",
        };

        const attach_document = {};

        for (const s of otherSections) {
          const f = s.field.toLowerCase();
          const v = s.values || {};

          if (v.documentId) {
            let docKey = getDocNameFromField(f);
            if (f === "identification") {
              if (v.identification_type === "aadhaar") docKey = "aadhaar";
              else if (v.identification_type === "pan_card") docKey = "pan_card";
            }
            attach_document[docKey] = v.documentId;
          }
          if (v.photoDocumentId) attach_document.profile_image = v.photoDocumentId;

          switch (f) {
            case "name":
              payload.meta_value.name = {
                first_name: v.first_name,
                middle_name: v.middle_name,
                last_name: v.last_name,
              };
              break;
            case "address":
              const selectedDistrict = districtList.find((d) => d.id == v.district);
              payload.meta_value.address = {
                city: v.district,
                city_name: selectedDistrict?.name || v.city || "",
                pincode: v.pincode,
                landmark: v.landmark,
                address: v.address,
              };
              break;
            case "state":
              payload.meta_value.state = { state: v.state };
              break;
            case "dob":
              payload.meta_value.date_of_birth = { dob: v.dob };
              break;
            case "bank_details":
              payload.meta_value.bank_details = {
                bank_name: v.bank_name,
                account_holder_name: v.account_holder_name,
                bank_account_number: v.account_number,
                branch_name: v.branch_name,
                ifsc_code: v.ifsc_code,
                cancelled_cheque_or_passbook_id:
                  attach_document.cancelled_cheque_or_passbook || v.cancelled_cheque_or_passbook_id,
              };
              break;
            case "sport":
              payload.meta_value.sport = { sport_id: v.sport_id };
              break;
            case "kit_size":
            case "shoe_size":
            case "height":
            case "weight":
            case "blood_group":
              payload.meta_value[f] = { [f]: v[f] };
              break;
            case "identification":
              payload.meta_value[f] = {
                identity_type: v.identification_type,
                identity_card: v.identification_number,
              };
              break;
            case "profile":
              payload.meta_value.profile_image = {
                profile_image: attach_document.profile_image || v.profile_image,
              };
              break;
            default:
              break;
          }
        }

        if (Object.keys(attach_document).length)
          payload.attach_document = attach_document;

        const apiPayload = {
          user_id: payload.user_id,
          meta_value: JSON.stringify(payload.meta_value),
          attach_document: JSON.stringify(payload.attach_document || {})
        };

        const response = await updateUserProfileDetails(apiPayload);
        if (!response?.data?.status) {
          notify("error", `${response?.data?.message}`);
          return;
        }
      }

      notify("success", userTypeSections.length > 0 && otherSections.length === 0
        ? "User type updated successfully"
        : "Profile updated successfully"
      );

      // Reload page so JWT/session reflects updated user type
      window.location.reload();
    } catch (err) {
      console.error("Error submitting update", err);
      notify("error", "Failed to update profile");
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendOtp = async (type, value) => {
    if (!value) return notify("error", `Enter a new ${type}`);
    try {
      const res = await sendMobileOtp(value);

      if (res?.data?.status) {
        notify("success", `OTP sent to your ${type}`);
        setMobileForm((f) => ({ ...f, otpSent: true }));
      } else {
        // Extract error message from response
        let errorMessage = "Failed to send OTP";

        if (res?.data?.message) {
          const msg = res.data.message;

          if (typeof msg === 'string') {
            errorMessage = msg;
          } else if (typeof msg === 'object') {
            // Extract from {"email":["Email already exist"]}
            const firstKey = Object.keys(msg)[0];
            const firstError = msg[firstKey];
            errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
          }
        }

        notify("error", errorMessage);
      }
    } catch (error) {
      // Handle network errors or exceptions
      let errorMessage = "Something went wrong while sending OTP";

      if (error?.response?.data?.message) {
        const msg = error.response.data.message;

        if (typeof msg === 'string') {
          errorMessage = msg;
        } else if (typeof msg === 'object') {
          const firstKey = Object.keys(msg)[0];
          const firstError = msg[firstKey];
          errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;
        }
      }

      notify("error", errorMessage);
    }
  };

  const verifyAndUpdate = async (type, value, otp) => {
    if (!value || !otp) return notify("error", "Enter both value and OTP");
    try {
      const updateRes = await updateUserMobileNumber(value, otp);
      if (updateRes?.data?.status || updateRes?.data?.success) {
        notify("success", `${type} updated successfully`);
        setShowMobileModal(false);
        fetchUserData();
      } else notify("error", updateRes?.data?.message || "Update failed");
    } catch (err) {
      console.error(err);
      notify("error", "Error verifying OTP");
    }
  };

  const openMobileModal = () => {
    setMobileForm({
      prev: entity?.mobile || "",
      next: "",
      otp: "",
      otpSent: false,
    });
    setShowMobileModal(true);
  };

  const openEmailModal = () => {
    setShowEmailModal(true);
  };

  const handleEmailDirectUpdate = async (newEmail) => {
    try {
      const res = await updateUserEmailDirect(newEmail);
      if (res?.data?.status || res?.data?.success) {
        notify("success", "Email updated successfully");
        setShowEmailModal(false);
        fetchUserData();
      } else {
        notify("error", res?.data?.message || "Failed to update email");
      }
    } catch (err) {
      notify("error", err?.response?.data?.message || "Failed to update email");
    }
  };

  useEffect(() => {
    setMobileForm((prev) => ({ ...prev, prev: entity?.mobile || "" }));
  }, [entity?.mobile]);

  const fullName = [userData.first_name, userData.middle_name, userData.last_name]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <PageTitle activeMenu="Edit Profile Request" motherMenu="Account Management" />

      <section>
        <div className="card px-4 py-3 mb-3">
          <UserHeader
            userProfileImage={userProfileImage}
            userData={userData}
            fullName={fullName}
            onBack={null}
          />
          <UserDetailsTable
            userData={userData}
            entity={entity}
            docs={docs}
            onEditMobile={openMobileModal}
            onEditEmail={openEmailModal}
            medicalHistory={medicalHistory}
          />
          <div className="d-flex justify-content-end px-2 pb-3">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-1"
              onClick={() => setShowPasswordModal(true)}
            >
              <span>Change Password</span>
            </button>
          </div>
        </div>

        <EditSections
          userData={userData}
          medicalHistory={medicalHistory}
          userProfileImage={userProfileImage}
          sections={sections}
          onAddSection={addSection}
          onRemoveSection={removeSection}
          onFieldChange={onFieldChange}
          onValueChange={onValueChange}
          onFileChange={(id, f) => handleFileUpload(id, f)}
          onPhotoFileChange={(id, f) => handleFileUpload(id, f, true)}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          validationErrors={validationErrors}
          clearValidationError={(id) =>
            setValidationErrors((prev) => {
              const copy = { ...prev };
              delete copy[id];
              return copy;
            })
          }
          kitSizeList={kitSizeList}
          stateList={stateList}
          districtList={districtList}
          onStateChange={handleStateChange}
          restrictedStateId={loggedInStateId}
          onFileRemove={handleFileRemove}
          mainCategories={mainCategories}
          categoryTypes={categoryTypes}
          subCategories={subCategories}
          onCategoryMainChange={handleCategoryMainChange}
          onCategoryTypeChange={handleCategoryTypeChange}
        />
      </section>

      {/* Mobile OTP Modal */}
      <OtpModal
        show={showMobileModal}
        onHide={() => setShowMobileModal(false)}
        title="Edit Mobile Number"
        helpText="Please enter valid mobile number"
        prevLabel="Previous Number"
        nextLabel="New Number"
        form={mobileForm}
        setForm={setMobileForm}
        onGetOtp={() => sendOtp("mobile", mobileForm.next)}
        onSubmit={(e) => {
          e.preventDefault();
          verifyAndUpdate("mobile", mobileForm.next, mobileForm.otp);
        }}
      />

      {/* Email Direct Edit Modal */}
      <EditEmailModal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        prevEmail={userData?.email || ""}
        onSubmit={handleEmailDirectUpdate}
      />

      {/* Change Password Modal */}
      <ChangePasswordModal
        show={showPasswordModal}
        onHide={() => setShowPasswordModal(false)}
      />
    </>
  );
};

export default EditProfileRequest;